const entity = {
  module: 'creativeManagement',
  singular: 'Creative',
  list: {
    page: 1,
    loading: true,
    search: '',
    shouldRetry: false,
    sortKey: 'id',
    sortOrder: 'desc',
    pagination: {
      perPage: import.meta.env.DEV ? 10 : 50,
      page: 1,
    },
    player: {
      id: null,
      isPlaying: false,
      progression: 0,
      source: null,
    },
    headers: [
      {
        key: 'gap-1',
        pages: [1, 2],
        size: '30px',
        heading: false,
        // classCell: 'tw-mt-4 tw-hidden',
        classHeader: 'tw-hidden',
      },
      {
        label: '',
        key: 'url',
        pages: [1, 2],
        heading: false,
        componentList: 'ListCellCreativePlay',
        classCell:
          'tw-mt-4 tw-border-t tw-h-12 tw-border-l tw-border-r tw-border-border tw-rounded-l tw-justify-center tw-text-md',
        classHeader: '',
        size: '50px',
      },
      {
        label: 'ID',
        key: 'id',
        pages: [1, 2],
        componentHeader: 'ListHeaderDefault',
        componentList: 'ListCellDefault',
        classCell: 'tw-px-2 tw-mt-4 tw-border-t tw-h-12',
        classHeader: 'tw-px-2',
        size: '80px',
      },
      {
        label: 'Status',
        key: 'statusComputed',
        sortable: false,
        pages: [1, 2],
        componentHeader: 'ListHeaderLabel',
        componentList: 'ListCellCreativeStatusComputed',
        classCell: 'tw-px-2 tw-mt-4 tw-border-t tw-h-12',
        classHeader: 'tw-px-2',
        size: '80px',
      },
      {
        label: 'Name',
        key: 'name',
        pages: [1],
        componentHeader: 'ListHeaderDefault',
        componentList: 'ListCellDefault',
        size: 'minmax(100px, 1fr)',
        classCell: 'tw-px-2 tw-mt-4 tw-border-t tw-h-12',
        classHeader: 'tw-px-2',
      },
      {
        label: 'Advertiser',
        key: 'advertiserDomain',
        pages: [1],
        componentHeader: 'ListHeaderDefault',
        componentList: 'ListCellDefault',
        size: 'minmax(100px, 1fr)',
        classCell: 'tw-px-2 tw-mt-4 tw-border-t tw-h-12',
        classHeader: 'tw-px-2',
      },
      {
        label: 'Language',
        key: 'detectedLanguage',
        sortable: false,
        pages: [2],
        componentHeader: 'ListHeaderLabel',
        componentList: 'ListCellDefault',
        size: 'minmax(40px, 0.5fr)',
        classCell: 'tw-px-2 tw-mt-4 tw-border-t tw-h-12',
        classHeader: 'tw-px-2',
      },
      {
        label: 'Manual Status',
        key: 'status',
        sortable: false,
        pages: [1],
        componentHeader: 'ListHeaderLabel',
        componentList: 'ListCellCreativeStatus',
        size: 'minmax(80px, 0.5fr)',
        classCell: 'tw-px-2 tw-mt-4 tw-border-t tw-h-12',
        classHeader: 'tw-px-2',
      },
      {
        label: 'Status AI',
        key: 'statusAi',
        sortable: false,
        pages: [1],
        componentHeader: 'ListHeaderLabel',
        componentList: 'ListCellCreativeStatusAi',
        size: 'minmax(80px, 0.5fr)',
        classCell: 'tw-px-2 tw-mt-4 tw-border-t tw-h-12',
        classHeader: 'tw-px-2',
      },
      {
        label: 'Duration',
        key: 'duration',
        sortable: false,
        pages: [2],
        componentHeader: 'ListHeaderLabel',
        componentList: 'ListCellCreativeDuration',
        size: 'minmax(80px, 0.5fr)',
        classCell: 'tw-px-2 tw-mt-4 tw-border-t tw-h-12',
        classHeader: 'tw-px-2',
      },
      {
        label: 'Actions',
        key: 'actions',
        pages: [1, 2],
        componentHeader: 'ListHeaderPagination',
        componentList: 'ListCellActions',
        size: '80px',
        classCell:
          'tw-mt-4 tw-border-t tw-h-12 tw-border-r tw-border-border tw-rounded-r',
        classHeader: '',
      },
    ],
    rowOptions: (item) => {
      const options = [
        ...(item.status !== 'Blacklisted'
          ? [
              {
                key: 'blocklist',
                label: 'Block Creative',
                icon: 'shield-x',
                class: item.statusAi === 'Blacklisted' ? 'tw-text-danger' : '',
              },
            ]
          : []),
        ...(item.status !== 'Whitelisted'
          ? [
              {
                key: 'allowlist',
                label: 'Allow creative',
                icon: 'shield-check',
                class: item.statusAi === 'Whitelisted' ? 'tw-text-success' : '',
              },
            ]
          : []),
      ]

      return options
    },
  },
}

export default entity
